import { render } from "./DialogOverResavationLimit.vue?vue&type=template&id=61a6fef4"
import script from "./DialogOverResavationLimit.vue?vue&type=script&lang=js"
export * from "./DialogOverResavationLimit.vue?vue&type=script&lang=js"
script.render = render

export default script